export const caseStudies = [
  {
    slug: 'grab',
    industry: 'B2C',
    brand: 'Grab',
    headline: 'Dynamic retargeting lifted Grab sales by 18% MoM',
    tags: ['Audience Segmentation'],
    metrics: [
      { value: '+28%', label: 'Conversion uplift' },
      { value: '+18%', label: 'More Sales (MoM)' },
      { value: '+35%', label: 'Site visits' },
    ],
    summary:
      'DSP audience segmentation by behavior drove 35% MoM visit increase. Dynamic creatives boosted monthly sales by 18%.',
    body:
      "Grab's digital team was struggling with broad CPM campaigns that could not tie spend back to verified sales. Retarget360.ai deployed a behavior-first segmentation model across the DSP, scoring every visitor on 100+ signals including product affinity, dwell time, and category velocity. Dynamic creative variants were auto-produced and A/B tested in real time. Within 60 days, confirmed sales climbed 18% month over month while blended CPA fell 31%.",
  },
  {
    slug: 'udemy',
    industry: 'EDTECH',
    brand: 'Udemy',
    headline: 'Udemy grew 41% more visits with intent-based retargeting MoM',
    tags: ['Dynamic Personalization'],
    metrics: [
      { value: '+30%', label: 'Conversion uplift' },
      { value: '+27%', label: 'More Orders (MoM)' },
      { value: '+41%', label: 'Visits (MoM)' },
    ],
    summary:
      'Behavioural purchase-intent segmentation drove a 41% MoM traffic surge. Custom landing pages with exclusive deals lifted CVR by 9%.',
    body:
      "Udemy operates at marketplace scale, which makes generic retargeting ineffective. Retarget360.ai's intent engine clustered buyers by category, price sensitivity, and repeat-purchase patterns. Personalized landing pages with exclusive deals were served to each segment. The result: a 41% MoM traffic surge and a 30% conversion uplift - all on a CPA-only model.",
  },
  {
    slug: 'Muscleblaze',
    industry: 'Sports · Global',
    brand: 'MuscleBlaze',
    headline: 'MuscleBlaze 4.5x sales with language-specific retargeting',
    tags: ['Lead Generation', 'Localization', 'CPS'],
    metrics: [
      { value: '4.5x', label: 'Sales' },
      { value: '4x', label: 'Conversion rate' },
      { value: '3x', label: 'Clicks' },
    ],
    summary:
      'Language-specific ad personalization drove 29% MoM quality traffic increase and 14% MoM lead growth across all markets.',
    body:
      "MuscleBlaze needed to scale 30+ language markets without building 30 campaign stacks. Retarget360.ai's DCO engine automatically produced localized creative per market, per intent tier. Lead quality - measured by 30-day activation - rose 14% MoM while the blended CPS dropped 38%.",
  },
];

export const getCaseStudyBySlug = (slug) => caseStudies.find((study) => study.slug === slug);
